import {
  ADD_UPDATE_PIAGGIO_ITEMDETAILS_FAILURE,
  ADD_UPDATE_PIAGGIO_ITEMDETAILS_REQUEST,
  ADD_UPDATE_PIAGGIO_ITEMDETAILS_SUCCESS,
  FETCH_PIAGGIO_ITEMDETAILS_LIST_FAILURE,
  FETCH_PIAGGIO_ITEMDETAILS_LIST_REQUEST,
  FETCH_PIAGGIO_ITEMDETAILS_LIST_SUCCESS,
} from "./actionTypes";
import { PiaggioItemDetails } from "./types";

export const fetchPiaggioItemDetailsListRequest = (
  url: string,
  payload: {
    pageNumber: number;
    pageSize: number;
    sortColumn: string;
    sortOrder: string;
    searchValue: string;
  }
) => ({
  type: FETCH_PIAGGIO_ITEMDETAILS_LIST_REQUEST,
  url,
  payload,
});

export const fetchPiaggioItemDetailsListSuccess = (
  piaggioItemDetailsList: PiaggioItemDetails[],
  totalCount: number
) => ({
  type: FETCH_PIAGGIO_ITEMDETAILS_LIST_SUCCESS,
  payload: { piaggioItemDetailsList, totalCount },
});

export const fetchPiaggioItemDetailsListFailure = (error: string) => ({
  type: FETCH_PIAGGIO_ITEMDETAILS_LIST_FAILURE,
  payload: error,
});

export const addUpdatePiaggioItemDetailsRequest = (
  url: string,
  payload: any,
  callback: unknown
) => ({
  type: ADD_UPDATE_PIAGGIO_ITEMDETAILS_REQUEST,
  url,
  payload,
  callback,
});

export const addUpdatePiaggioItemDetailsSuccess = (successMessage: string) => ({
  type: ADD_UPDATE_PIAGGIO_ITEMDETAILS_SUCCESS,
  payload: { successMessage },
});

export const addUpdatePiaggioItemDetailsFailure = (error: string) => ({
  type: ADD_UPDATE_PIAGGIO_ITEMDETAILS_FAILURE,
  payload: error,
});
